import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import TablaDetalleMercaderiaSecadaView from '../../components/listados/TablaDetalleMercaderiaSecadaView'
import { actualizarDetalleMercaderiaSecada } from '../../actions/listados'

function DetalleMercaderiaSecada (props) {
  const { detalle, fechaDesde, fechaHasta, actualizarDetalleMercaderiaSecada } = props

  useEffect(() => {
    actualizarDetalleMercaderiaSecada(fechaDesde, fechaHasta, detalle.exportador, detalle.cereal)
  }, [actualizarDetalleMercaderiaSecada, fechaDesde, fechaHasta, detalle])

  return (
    <>
      <TablaDetalleMercaderiaSecadaView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDetalleMercaderiaSecada
}

const mapStateToProps = state => {
  return {
    fechaDesde: state.stock.fechaDesde,
    fechaHasta: state.stock.fechaHasta
  }
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleMercaderiaSecada)
